document.addEventListener('DOMContentLoaded', function () {
  const megamenuTriggers = document.querySelectorAll('.has-megamenu');
  const header = document.querySelector('.megamenu-header');
  const html = document.querySelector('html');
  const body = document.querySelector('body');
  let currentMegamenu = null;
  let currentTrigger = null;

  // Desktop megamenu
  megamenuTriggers.forEach(function (trigger) {
    const menuHandle = trigger.getAttribute('data-menu-handle');
    const megamenu = document.getElementById('megamenu-' + menuHandle);

    if (megamenu) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();

        if (currentMegamenu === megamenu) {
          megamenu.classList.remove('show');
          header.classList.remove('design-white');
          megamenu.classList.remove('design-white');
          html.classList.remove('overflow-hidden');
          body.classList.remove('overflow-hidden');
          currentMegamenu = null;
          currentTrigger = null;
          trigger.classList.remove('open');
          document.removeEventListener('click', closeMegamenuOnOutsideClick);
          document.removeEventListener('keydown', closeMegamenuOnEscape);
        } else {
          document.querySelectorAll('.megamenu').forEach(function (m) {
            m.classList.remove('show');
            m.classList.remove('design-white');
          });

          document.querySelectorAll('.has-megamenu').forEach(function (t) {
            t.classList.remove('open');
          });

          megamenu.classList.add('show');
          trigger.classList.add('open');
          header.classList.add('design-white');
          megamenu.classList.add('design-white');
          html.classList.add('overflow-hidden');
          body.classList.add('overflow-hidden');
          currentMegamenu = megamenu;
          currentTrigger = trigger;
          setTimeout(() => {
            document.addEventListener('click', closeMegamenuOnOutsideClick);
            document.addEventListener('keydown', closeMegamenuOnEscape);
          }, 5);
          hideMegamenu();
          hideOverlay();
        }
      });
    }
  });

  function closeMegamenuOnOutsideClick(e) {
    if (!currentMegamenu) return;

    const isClickInsideMegamenu = currentMegamenu.contains(e.target);
    const isClickOnTrigger = currentTrigger && currentTrigger.contains(e.target);
    const isClickOnLink = e.target.closest('a');

    const clickedOutsideMegamenu = !isClickInsideMegamenu;
    const clickedInsideButNotOnLink = isClickInsideMegamenu && !isClickOnLink;
    const shouldCloseMegamenu = (clickedOutsideMegamenu || clickedInsideButNotOnLink) && !isClickOnTrigger;
    if (shouldCloseMegamenu) {
      currentMegamenu.classList.remove('show');
      currentTrigger.classList.remove('open');
      header.classList.remove('design-white');
      currentMegamenu.classList.remove('design-white');
      html.classList.remove('overflow-hidden');
      body.classList.remove('overflow-hidden');
      
      document.removeEventListener('click', closeMegamenuOnOutsideClick);
      document.removeEventListener('keydown', closeMegamenuOnEscape);
      
      currentMegamenu = null;
      currentTrigger = null;
    }
  }

  function closeMegamenuOnEscape(e) {
    if (e.key === 'Escape' && currentMegamenu) {
      currentMegamenu.classList.remove('show');
      currentTrigger.classList.remove('open');
      header.classList.remove('design-white');
      currentMegamenu.classList.remove('design-white');
      html.classList.remove('overflow-hidden');
      body.classList.remove('overflow-hidden');
      
      document.removeEventListener('click', closeMegamenuOnOutsideClick);
      document.removeEventListener('keydown', closeMegamenuOnEscape);
      
      currentMegamenu = null;
      currentTrigger = null;
    }
  }

  // Mobile menu
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenuToggleOffButtons = document.querySelectorAll('.mobile-menu-toggle-off');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuMain = document.querySelector('.mobile-menu-main');

  if (mobileMenuToggle && mobileMenu && mobileMenuMain) {
    // Toggle mobile menu
    mobileMenuToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = mobileMenu.classList.contains('open');

      if (isOpen) {
        mobileMenuToggle.classList.remove('active');
        mobileMenu.classList.remove('open');
        header.classList.remove('mobile-menu-active');
        document.body.classList.remove('mobile-menu-open');

        setTimeout(function () {
          mobileMenuMain.classList.remove('slide-left');
          document.querySelectorAll('.mobile-menu-submenu').forEach(function (submenu) {
            submenu.classList.remove('active');
          });
          document.querySelectorAll('.mobile-submenu-item').forEach(function (item) {
            item.classList.remove('active');
          });
        }, 200);
      } else {
        mobileMenuToggle.classList.add('active');
        mobileMenu.classList.add('open');
        header.classList.add('mobile-menu-active');
        document.body.classList.add('mobile-menu-open');
      }
    });

    mobileMenuToggleOffButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        const isOpen = mobileMenu.classList.contains('open');

        if (isOpen) {
          mobileMenuToggle.classList.remove('active');
          mobileMenu.classList.remove('open');
          header.classList.remove('mobile-menu-active');
          document.body.classList.remove('mobile-menu-open');

          setTimeout(function () {
            mobileMenuMain.classList.remove('slide-left');
            document.querySelectorAll('.mobile-menu-submenu').forEach(function (submenu) {
              submenu.classList.remove('active');
            });
            document.querySelectorAll('.mobile-submenu-item').forEach(function (item) {
              item.classList.remove('active');
            });
          }, 200);
        } else {
          mobileMenuToggle.classList.add('active');
          mobileMenu.classList.add('open');
          header.classList.add('mobile-menu-active');
          document.body.classList.add('mobile-menu-open');
        }
      });
    });

    // Click on main link in mobile
    const mainTriggers = document.querySelectorAll('.mobile-menu-trigger.has-submenu');
    mainTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const menuHandle = trigger.getAttribute('data-menu');
        const submenu = document.getElementById('mobile-submenu-' + menuHandle);
        if (submenu) {
          mobileMenuMain.classList.add('slide-left');
          submenu.classList.add('active');
        }
      });
    });

    // Back button
    const backButtons = document.querySelectorAll('.mobile-menu-back');
    backButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        mobileMenuMain.classList.remove('slide-left');
        document.querySelectorAll('.mobile-menu-submenu').forEach(function (submenu) {
          submenu.classList.remove('active');
        });
        document.querySelectorAll('.mobile-submenu-item').forEach(function (item) {
          item.classList.remove('active');
        });
      });
    });

    // Accordion in submenu
    const submenuTriggers = document.querySelectorAll('.mobile-submenu-trigger');
    submenuTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const parent = trigger.closest('.mobile-submenu-item');
        const isActive = parent?.classList.contains('active');

        parent?.classList.toggle('active', !isActive);

      });
    });

  }
});

function adjustContentHeight() {
  const container = document.querySelector('.megamenu-section');
  const header = document.querySelector('.megamenu-header');
  const contents = document.querySelectorAll('.megamenu');
  const mobilemenu = document.querySelector('.mobile-menu');
  const announcement = document.getElementById('shopify-section-announcement');
  const mobilemenuheader = document.querySelector('.mobile-menu-header');
  const mobilemenuinner = document.querySelectorAll('.mobile-menu-inner');

  // safety check
  if (!container || !header || !mobilemenu || !contents.length || !mobilemenuheader) return;

  const containerTop = container.getBoundingClientRect().top;
  const headerHeight = header.offsetHeight;
  const announcementHeight = announcement ? announcement.offsetHeight : 0;
  const mobilemenuheaderHeight = mobilemenuheader ? mobilemenuheader.offsetHeight : 0;

  contents.forEach(content => {
    content.style.height = `calc(100vh - ${containerTop + headerHeight}px)`;
  });
  mobilemenu.style.height = `calc(100vh - ${announcementHeight}px)`;
  mobilemenu.style.top = `0px`;

  mobilemenuinner.forEach(mobilemenuinneritem => {
    mobilemenuinneritem.style.height = `calc(100dvh - ${mobilemenuheaderHeight + announcementHeight}px)`;
  });
}

function positionMegamenu() {
  const menus = document.querySelectorAll(".js-megamenu");
  const header = document.querySelector(".megamenu-header");
  if (!header) return;

  const isFixedMobile = header.classList.contains("header--fixed-mobile");
  const isFixedDesktop = header.classList.contains("header--fixed-desktop");
  const headerHeight = header.offsetHeight;

  menus.forEach(menu => {
    menu.classList.add("w-screen", "absolute");

    // if header fixed
    if (isFixedMobile || isFixedDesktop) {
      menu.style.top = "36px";
    } else if (window.innerWidth < 1450) {
      menu.style.top = "80px";
    } else {
      menu.style.top = "36px";
    }

    // left offset
    const navParent = menu.closest(".megamenu-part");
    if (!navParent) return;

    const parentRect = navParent.getBoundingClientRect();
    const leftOffset = parentRect.left;
    menu.style.left = `-${leftOffset}px`;
  });
}

window.addEventListener('DOMContentLoaded', adjustContentHeight);

let lastWidth = window.innerWidth;
let lastHeight = window.innerHeight;

window.addEventListener('resize', function() {
  const currentWidth = window.innerWidth;
  const currentHeight = window.innerHeight;
  
  const widthDiff = Math.abs(currentWidth - lastWidth);
  const heightDiff = Math.abs(currentHeight - lastHeight);
  
  const RESIZE_THRESHOLD = 20;

  if (widthDiff >= RESIZE_THRESHOLD || heightDiff >= RESIZE_THRESHOLD) {
    adjustContentHeight();
    positionMegamenu();
    lastWidth = currentWidth;
    lastHeight = currentHeight;
  }
});

window.addEventListener("DOMContentLoaded", positionMegamenu);

const SCROLL_THRESHOLD = 800;

window.addEventListener("scroll", function() {
  const scrollPosition = window.scrollY || window.pageYOffset;
  const isNearTop = scrollPosition < SCROLL_THRESHOLD;
  
  if (isNearTop) {
    adjustContentHeight();
    positionMegamenu();
  }
});

const initializedElements = new WeakSet();
const DRAG_THRESHOLD = 5;

function initSingleElement(scrollContainer) {
  if (initializedElements.has(scrollContainer)) {
    return;
  }

  const width = scrollContainer.offsetWidth;
  const scrollWidth = scrollContainer.scrollWidth;
  const hasOverflow = scrollWidth > width;

  let isDown = false;
  let startX;
  let startY;
  let scrollLeft;
  let hasMoved = false;

  scrollContainer.addEventListener('mousedown', (e) => {
    isDown = true;
    hasMoved = false;
    scrollContainer.style.cursor = 'grabbing';
    scrollContainer.classList.add('is-dragging');
    startX = e.pageX - scrollContainer.offsetLeft;
    startY = e.pageY;
    scrollLeft = scrollContainer.scrollLeft;

    e.preventDefault();
  });

  scrollContainer.addEventListener('mouseleave', () => {
    isDown = false;
    scrollContainer.style.cursor = 'grab';
    scrollContainer.classList.remove('is-dragging');
  });

  scrollContainer.addEventListener('mouseup', () => {
    isDown = false;
    scrollContainer.style.cursor = 'grab';
    scrollContainer.classList.remove('is-dragging');
  });

  scrollContainer.addEventListener('mousemove', (e) => {
    if (!isDown) return;

    const x = e.pageX - scrollContainer.offsetLeft;
    const y = e.pageY;
    const distanceX = Math.abs(x - startX);
    const distanceY = Math.abs(y - startY);

    if (distanceX > DRAG_THRESHOLD || distanceY > DRAG_THRESHOLD) {
      hasMoved = true;
    }

    e.preventDefault();

    const walk = (x - startX) * 2;
    const newScrollLeft = scrollLeft - walk;

    scrollContainer.scrollLeft = newScrollLeft;
  });

  scrollContainer.addEventListener('click', (e) => {
    if (hasMoved) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true);

  const links = scrollContainer.querySelectorAll('a');
  links.forEach(link => {
    link.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });
  });

  initializedElements.add(scrollContainer);
}

function checkAndInitElements() {
  const scrollContainers = document.querySelectorAll('.scrollable-products-4-plus');

  scrollContainers.forEach((container, index) => {
    if (!initializedElements.has(container) && container.offsetWidth > 0) {
      initSingleElement(container, index);
    }
  });
}

const observer = new MutationObserver((mutations) => {
  checkAndInitElements();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['class', 'style']
});

document.addEventListener('mouseenter', (e) => {
  if (e?.target?.classList?.contains('scrollable-products-4-plus')) {
    const containers = Array.from(document.querySelectorAll('.scrollable-products-4-plus'));
    const index = containers.indexOf(e.target);
    initSingleElement(e.target, index);
  }
}, true);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    checkAndInitElements();
  });
} else {
  checkAndInitElements();
}
